import { createContext } from 'react';
import { ApplicationContextProps } from './application.context.interfaces';

const initialContext: ApplicationContextProps = {
  basePath: '',
  glyph: '',
  isActive: false,
  isDeployed: false,
  isStandalone: false,
  name: '',
  order: 0,
  preferenceKey: '',
  securityAttributeId: 0,
  version: ''
};

export const ApplicationContext =
  createContext<ApplicationContextProps>(initialContext);
